import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, mergeMap, take } from 'rxjs/operators';
import { AuthService } from '@services/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  private refreshTokenInProgress = false;
  private refreshTokenSubject = new BehaviorSubject<boolean | null>(null);
  private authService = inject(AuthService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(response => {

      if (request.url.includes('public/refresh')) {
        if (this.authService.loggedUser) {
          this.authService.logout();
        }
        return throwError(response);
      }

      if (response.status === 500) {
        return throwError(response);
      }

      // if (response.status >= 401 && response.status < 500) {
      if (response.status === 401) {

        if (this.refreshTokenInProgress) {
          return this.refreshTokenSubject.pipe(
            filter(result => result !== null),
            take(1),
            mergeMap(() => next.handle(request))
          );
        } else {
          this.refreshTokenInProgress = true;
          this.refreshTokenSubject.next(null);

          return this.authService.refresh().pipe(
            mergeMap(() => {
              this.refreshTokenInProgress = false;
              this.refreshTokenSubject.next(true);

              return next.handle(request);
            }),
            catchError((err) => {
                this.refreshTokenInProgress = false;
                return throwError(err);
              }
            ));
        }
      }

      if (response?.error instanceof Blob) {
        this.handleBlobError(response?.error);
      } else if (!response?.error?.skipErrorInterceptor && response.status !== 0) {
        // this.layoutUtilService.showError(response.error?.message || 'Operation failed.');
      }
      return throwError(response);

    }));
  }

  private handleBlobError(blobError: Blob) {
    let normalizedError = null

    this.readFromBlob(blobError).then((result) => {
      normalizedError = result;
      if (!normalizedError?.skipErrorInterceptor) {
        // this.layoutUtilService.showError(normalizedError?.message || 'Operation failed.');
      }
    });
  }

  //https://github.com/angular/angular/issues/19888
  readFromBlob(blob: Blob) {
    return new Promise((resolve, reject) => {
      const fr = new FileReader();

      fr.onloadend = e => {
        if (typeof e.target.result === 'string') {
          resolve(JSON.parse(e.target.result));
        }
      };

      fr.readAsText(blob);
    });
  }

}
